module.exports = __webpack_public_path__ + "static/media/spinner-blue.4351f771.svg";